import { getOrCreateKeyPairSafe } from '@/lib/crypto.migrationWrapper';
import { getOrCreateSigningKeyPair } from '@/lib/signing';
import { registerSigningPublicKey, exportSigningPublicKey } from '@/lib/publicKeyRegistry';
import { registerDevice } from '@/lib/deviceIdentity';
import { logger } from '@/lib/logger';

/**
 * Sets up encryption keys, signing keys, and device registration.
 * Returns the private encryption key.
 */
export async function setupKeysAndDevice(userId: string): Promise<CryptoKey> {
  const [encResult, sigResult] = await Promise.all([
    getOrCreateKeyPairSafe(userId),
    getOrCreateSigningKeyPair(userId),
  ]);

  // Register signing public key + device (non-critical, fire-and-forget-ish)
  if (sigResult.publicKey) {
    try {
      await registerSigningPublicKey(userId, sigResult.publicKey);
    } catch (e) {
      logger.warn('Signing key registration failed:', e);
    }

    try {
      const exported = await exportSigningPublicKey(sigResult.publicKey);
      logger.debug('Registering device for user');
      await registerDevice(userId, exported);
      logger.debug('Device registration completed');
    } catch (e) {
      logger.error('Device registration failed:', e);
    }
  }

  return encResult.privateKey;
}
